"use client";

import React from "react";
import { Facebook, Instagram, MapPin, MessageCircle, Phone, Twitter } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterLinks() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="space-y-3">
        {[1, 2, 3].map((_, i) => <li key={i} data-index={i}>
            <div className="h-5 w-24 bg-muted/50 animate-pulse rounded" />
          </li>)}
      </ul>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-muted-foreground hover:text-sidebar-primary transition-colors text-base font-medium font-sans">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function FooterInformation() {
  return <section data-section-id="188999" id="footer" className="dark bg-background text-foreground pt-16 pb-8 relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {}
          <div className="flex flex-col items-start">
            <Link to="/">
              <img src="https://moonriseresidentialcare.com/wp-content/uploads/2026/06/MoonRise-transparent-02-scaled.png" alt="Moonrise Residential Care" className="mb-6 h-80 object-contain" />
            </Link>
            <p className="text-muted-foreground text-lg leading-relaxed max-w-sm font-sans">
              Providing a safe, loving, and community-focused living environment for seniors in McKinney, Texas. Dedicated to compassionate, high-quality, and personalized elder care.
            </p>
          </div>

          {}
          <div>
            <h3 className="text-xl font-sans font-bold tracking-tight mb-6 text-[#ffbd00]">
              Quick Links
            </h3>
            <MenuProvider menu_id="62">
              <FooterLinks />
            </MenuProvider>
          </div>

          {}
          <div>
            <h3 className="text-xl font-sans font-bold tracking-tight mb-6 text-[#ffbd00]">
              Contact Us
            </h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3 text-muted-foreground text-lg font-sans">
                <MapPin className="h-6 w-6 shrink-0 text-[#ffbd00]" />
                <span>McKinney, Texas</span>
              </li>
              <li className="flex items-center gap-3 text-muted-foreground text-lg font-sans">
                <Phone className="h-6 w-6 shrink-0 text-[#ffbd00]" />
                <span>972.987.0475 / 469.922.3702</span>
              </li>
            </ul>

            <div className="flex gap-3 mt-8">
              <Button variant="ghost" size="icon" asChild className="text-muted-foreground hover:text-sidebar-primary hover:bg-sidebar-primary/10 bg-transparent rounded-lg transition-colors">
                <Link aria-label="Facebook" href="https://www.facebook.com/profile.php?id=61588977195724" newTab>
                  <Facebook className="h-5 w-5 text-[#ffbd00]" />
                </Link>
              </Button>
              <Button variant="ghost" size="icon" asChild className="text-muted-foreground hover:text-sidebar-primary hover:bg-sidebar-primary/10 bg-transparent rounded-lg transition-colors">
                <Link to="#" newTab aria-label="Twitter">
                  <Twitter className="h-5 w-5 text-[#ffbd00]" />
                </Link>
              </Button>
              <Button variant="ghost" size="icon" asChild className="text-muted-foreground hover:text-sidebar-primary hover:bg-sidebar-primary/10 bg-transparent rounded-lg transition-colors">
                <Link aria-label="Instagram" href="https://www.instagram.com/thinkmoonriseresidentialcare/" newTab>
                  <Instagram className="h-5 w-5 text-[#ffbd00]" />
                </Link>
              </Button>
            </div>
          </div>
        </div>

        <Separator className="bg-border/20" />
        
        <div className="mt-8 text-center text-base text-muted-foreground font-sans">
          <p>© 2026 Moonrise Residential Care, LLC. All rights reserved.</p>
        </div>
      </div>

      {}
      <div className="fixed bottom-6 right-6 z-50">
        <div className="relative flex items-center justify-center">
          <span className="absolute inline-flex h-full w-full animate-ping rounded-lg bg-sidebar-primary opacity-30 duration-1000"></span>
          <Button asChild size="icon" className="relative h-14 w-14 rounded-lg bg-sidebar-primary hover:bg-sidebar-primary/90 text-black font-bold shadow-2xl border-none transition-transform hover:scale-105">
            <Link to="https://wa.me/19725550123" newTab>
              <MessageCircle className="h-7 w-7 text-[#ffbd00]" />
              <span className="sr-only">Inquire on WhatsApp</span>
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}